export default __webpack_public_path__ + "static/media/msat-instr-test-card-2.378372da.svg";